import { memo } from 'react';
import { cx } from '@emotion/css';

import type { ChipProps as MuiChipProps } from '@mui/material';
import { Chip as MuiChip } from '@mui/material';

import cn from './tag.module.scss';

//[Link to Figma](https://www.figma.com/design/haLJY8Z5UGGqIbRajgg9GP/Design-system?node-id=2271-22913&node-type=frame&t=ribwKhhlVK1mbX6y-0)

const Tag = ({ className, ...props }: MuiChipProps) => {
    return (
        <MuiChip
            className={cx(cn.container, className)}
            {...props}
        />
    );
};

export default memo(Tag);
